export default __webpack_public_path__ + "f54ef3fc45d5a014e494cb200313a790.svg";